<script setup lang="ts">
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import {
  addOnModalDialogPt,
  addOnRequestsPresets,
} from "@/components/StudentFulfillment/components/OrderDetail/sections/Details/AddOnRequests/styles";
import type {
  AddOnDropdownOption,
  AddOnRequestItem,
} from "@/components/StudentFulfillment/components/OrderDetail/sections/Details/AddOnRequests/types";
import RefreshCircleIcon from "@/components/shared/icons/RefreshCircleIcon.vue";

defineOptions({ name: "AddOnStatusChangeModal" });

const props = withDefaults(
  defineProps<{
    visible: boolean;
    item?: AddOnRequestItem;
    targetStatus?: AddOnDropdownOption;
    saving?: boolean;
  }>(),
  {
    item: undefined,
    targetStatus: undefined,
    saving: false,
  },
);

const emit = defineEmits<{
  (e: "update:visible", value: boolean): void;
  (e: "confirm"): void;
}>();

const handleHide = (): void => {
  emit("update:visible", false);
};
</script>

<template>
  <Dialog
    :visible="visible"
    modal
    :closable="!saving"
    :pt="addOnModalDialogPt"
    :style="{ width: '520px' }"
    data-testid="add-on-status-change-modal"
    @update:visible="handleHide"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <span class="flex w-8 h-8 rounded-lg bg-teal-50 items-center justify-center flex-none">
          <RefreshCircleIcon class="h-4 w-4 text-teal-900" />
        </span>
        <span class="text-lg font-bold text-indigo-base">Update request status</span>
      </div>
    </template>

    <p class="text-15p leading-relaxed text-gray-600" data-testid="add-on-status-change-description-text">
      Change the status of <span class="font-bold text-indigo-base">{{ item?.name }}</span> to
      <span class="font-bold text-indigo-base">{{ targetStatus }}</span>?
    </p>

    <template #footer>
      <Button
        label="Cancel"
        outlined
        :disabled="saving"
        data-testid="add-on-status-change-cancel-button"
        :pt="addOnRequestsPresets.outlinedTealButton"
        @click="handleHide"
      />
      <Button
        label="Update Status"
        :loading="saving"
        data-testid="add-on-status-change-confirm-button"
        :pt="addOnRequestsPresets.primaryButton"
        @click="emit('confirm')"
      />
    </template>
  </Dialog>
</template>
